module.exports = __webpack_public_path__ + "img/banner_policy_1.2011c893.jpg";